module.exports = __webpack_public_path__ + "img/20191024171930410.a1c2ec5b.jpg";